module.exports = __webpack_public_path__ + "static/media/delivery2.eef48165.png";